// Korpa kao lista osoba (accordion). Sloj iznad ecomm.ski komponenti (ag-ski-cart-item.js / ag-ecommski-cart.js):
// ne mijenja njihov ugovor, samo čita stanje svake osobe (window.agSki.items), vodi korisnika kroz popunjavanje,
// čuva od duplog talona, sam prelazi na sljedeću osobu čim je talon ispravno upisan (nema dugmeta "Gotovo")
// i drži dugme "Plati" zaključanim dok sve nije kompletno.
// Slanje forme (spremanje svih osoba i prelazak na checkout) radi ag-ecommski-cart.js, ovdje se ništa ne šalje.
(function () {
  var root = document.querySelector('[data-ag-cart]');
  if (!root) return;

  var persons = Array.prototype.slice.call(root.querySelectorAll('[data-ag-person]'));
  var pay = root.querySelector('[data-ag-pay]');
  var hint = root.querySelector('[data-ag-hint]');
  var confirmBox = root.querySelector('[data-ag-confirm]');
  var confirmWrap = root.querySelector('[data-ag-confirm-wrap]');
  var countEl = root.querySelector('[data-ag-progress-count]');
  var bars = Array.prototype.slice.call(root.querySelectorAll('.ags-progress__bar'));
  var OPEN_KEY = 'ag-cart-open';
  var CONFIRM_KEY = 'ag-cart-confirm';
  var firstOpenDone = false;
  var tries = 0;

  function store(key, value) {
    try { if (value == null) sessionStorage.removeItem(key); else sessionStorage.setItem(key, value); } catch (e) { /* bez storage-a radi i dalje */ }
  }
  function read(key) {
    try { return sessionStorage.getItem(key); } catch (e) { return null; }
  }

  function itemOf(person) {
    var reg = window.agSki && window.agSki.items;
    if (!reg) return null;
    var found = null;
    reg.forEach(function (it) {
      if (it._el && person.contains(it._el)) found = it;
    });
    return found;
  }

  // Šta još fali (bez ispisa grešaka u polja: to radi isFormValid tek na "Plati")
  function missing(item, layout) {
    var out = [];
    if (layout === 1 || layout === 4) {
      if (item.nameError(item.firstName, 'Ime', 2)) out.push('ime');
      if (item.nameError(item.lastName, 'Prezime', 1)) out.push('prezime');
      if (item.dobError()) out.push('datum rođenja');
      if (!item.fileToUpload && !item.imageAlreadySaved) out.push('fotografija');
    }
    var hasCard = !!item.keyCardId;
    if (hasCard) {
      if (item.keyCardError()) out.push('ID talona');
    } else if (layout === 1 && item.delivery) {
      /* dostava poštom: talon nije potreban */
    } else if (layout === 2 && item.pickUp) {
      /* preuzimanje na SKIOSK-u */
    } else {
      out.push(layout === 1 ? 'ID talona ili dostava' : 'ID talona');
    }
    return out;
  }

  function digits(v) { return (v || '').replace(/\D/g, ''); }

  // Korisnik trenutno upisuje ID talona u ovoj osobi (fokus je u polju talona)
  function inTalon(person) {
    var a = document.activeElement;
    return !!(a && person.contains(a) && a.matches && a.matches('[data-maska]'));
  }

  // Prvi problem u otvorenoj osobi: duplikat talona ima prednost, pa prva greška u polju
  function scrollToProblem(person) {
    var dup = person.querySelector('[data-ag-dup]:not([hidden])');
    var el = dup || person.querySelector('.ag-field__error, .ski-cart-item__error');
    if (!el) {
      person.style.scrollMarginTop = '84px';
      person.scrollIntoView({ block: 'start', behavior: 'smooth' });
      return;
    }
    el.scrollIntoView({ block: 'center', behavior: 'smooth' });
    if (dup) {
      var input = person.querySelector('[data-maska]');
      if (input) input.focus({ preventScroll: true });
    }
  }

  function render() {
    var done = 0;
    var firstMissing = [];
    var cards = [];
    var seen = {};
    var lastSurname = '';
    var loading = !!(window.agSki && window.agSki.loading);

    persons.forEach(function (person, i) {
      var item = itemOf(person);
      var layout = Number(person.dataset.layout) || 0;
      var info = { person: person, item: item, missing: null, dup: '' };
      cards.push(info);
      if (!item) return;

      var miss = missing(item, layout);
      info.missing = miss;

      // duplikat talona unutar korpe
      var dupEl = person.querySelector('[data-ag-dup]');
      var card = item.keyCardId && !item.keyCardError() ? digits(item.keyCardId) : '';
      if (card) {
        if (seen[card] != null) {
          info.dup = 'Ovaj talon je već upisan za osobu ' + (seen[card] + 1) + '. Jedan talon može imati samo jednu sezonsku kartu. Provjerite broj.';
        } else {
          seen[card] = i;
        }
      }
      if (dupEl) {
        if (info.dup) { dupEl.textContent = info.dup; dupEl.hidden = false; } else { dupEl.hidden = true; }
      }
      if (info.dup) {
        if (person.dataset.dup !== 'true') person.dataset.dup = 'true';
        // poruka se pojavi dok korisnik kuca talon: ostani na tom polju (na mobilnom je poruka inače ispod tastature)
        if (!person._dup && dupEl && inTalon(person)) {
          setTimeout(function () { dupEl.scrollIntoView({ block: 'center', behavior: 'smooth' }); }, 60);
        }
        person._dup = true;
      } else {
        if (person.dataset.dup) delete person.dataset.dup;
        person._dup = false;
      }

      var complete = miss.length === 0 && !info.dup;

      // Talon upravo ispravno upisan i osoba je kompletna: nema "Gotovo", korpa sama ide dalje
      if (person._card === undefined) {
        person._card = card; // prvo čitanje (učitavanje zapisa) ne pokreće prelazak
      } else if (person._card !== card) {
        person._card = card;
        if (card && complete && firstOpenDone && person.dataset.open === 'true' && inTalon(person)) scheduleAdvance(person);
      }
      var typed = item.firstName || item.lastName || item.dobDay || item.dobMonth || item.dobYear || item.keyCardId || item.fileToUpload || item.imageAlreadySaved || item.delivery || item.pickUp;
      var state = complete ? 'done' : (typed ? 'part' : 'empty');
      if (person.dataset.state !== state) person.dataset.state = state;

      var nameEl = person.querySelector('[data-ag-name]');
      var full = ((item.firstName || '') + ' ' + (item.lastName || '')).trim();
      if (nameEl) {
        var label = full || ('Osoba ' + (i + 1) + (persons.length > 1 ? ' od ' + persons.length : ''));
        if (nameEl.textContent !== label) nameEl.textContent = label;
      }
      var statusEl = person.querySelector('[data-ag-status]');
      if (statusEl) {
        var st = complete ? 'kompletno' : (info.dup ? 'talon je duplikat' : (typed ? 'još treba: ' + miss.join(', ') : 'još nije popunjeno'));
        if (statusEl.textContent !== st) statusEl.textContent = st;
      }
      var act = person.querySelector('[data-ag-act]');
      if (act) act.textContent = complete ? 'Izmijeni' : (typed ? 'Nastavi' : 'Popuni');
      var avatar = person.querySelector('[data-ag-avatar]');
      if (avatar && full) {
        var ini = (item.firstName || '').charAt(0) + (item.lastName || '').charAt(0);
        if (avatar.textContent !== ini.toUpperCase()) avatar.textContent = ini.toUpperCase();
      }

      // prijedlog prezimena iz prethodne osobe
      var chipRow = person.querySelector('[data-ag-chip]');
      if (chipRow) {
        var btn = chipRow.querySelector('[data-ag-chip-btn]');
        if (!item.lastName && lastSurname && person.dataset.open === 'true') {
          if (btn.textContent !== lastSurname) btn.textContent = lastSurname;
          chipRow.hidden = false;
        } else {
          chipRow.hidden = true;
        }
      }
      if (item.lastName && item.nameError(item.lastName, 'Prezime', 1) === '') lastSurname = item.lastName;

      if (complete) done++; else firstMissing.push('Osoba ' + (i + 1) + (info.dup ? ' (talon se ponavlja)' : ''));
    });

    // progres
    bars.forEach(function (bar, i) {
      var p = persons[i];
      var s = p ? (p.dataset.state === 'done' ? 'done' : (p.dataset.open === 'true' ? 'open' : 'todo')) : 'todo';
      if (bar.dataset.state !== s) bar.dataset.state = s;
    });
    if (countEl) countEl.textContent = persons.length ? done + ' od ' + persons.length + ' kompletno' : '';

    // potvrda Loyalty prava
    var needConfirm = !!confirmBox;
    var confirmed = !needConfirm || confirmBox.checked;

    var allDone = persons.length > 0 && done === persons.length;
    var ready = allDone && confirmed;
    if (pay) {
      pay.dataset.ready = ready ? 'true' : 'false';
      pay.setAttribute('aria-disabled', ready ? 'false' : 'true');
    }
    if (hint) {
      var msg = '';
      if (!persons.length) msg = '';
      else if (loading && !allDone) msg = 'Učitavam podatke...';
      else if (!allDone) msg = 'Još treba popuniti: ' + firstMissing.join(', ');
      else if (!confirmed) msg = 'Potvrdite Loyalty pravo za nastavak';
      else msg = 'Plaćanje karticom na sljedećem koraku';
      if (hint.textContent !== msg) hint.textContent = msg;
    }
    return { cards: cards, allDone: allDone, confirmed: confirmed };
  }

  // Ono što je radilo dugme "Dalje"/"Gotovo": spremi osobu pa otvori sljedeću nepopunjenu ili idi na potvrdu i plaćanje
  function advance(person) {
    var item = itemOf(person);
    if (!item) return;
    item.partialSave();
    var idx = persons.indexOf(person);
    var nxt = firstIncomplete(idx + 1) || firstIncomplete(0);
    if (nxt && nxt !== person) {
      openPerson(nxt);
    } else {
      openPerson(null, { scroll: false });
      var target = confirmWrap || pay;
      if (target) target.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  }

  function scheduleAdvance(person) {
    clearTimeout(person._adv);
    person._adv = setTimeout(function () {
      render();
      if (person.dataset.state !== 'done' || person.dataset.open !== 'true') return;
      var a = document.activeElement;
      if (a && person.contains(a) && a.matches && a.matches('input') && !a.matches('[data-maska]')) return; // korisnik je prešao na drugo polje
      advance(person);
    }, 900);
  }

  function openPerson(person, opts) {
    opts = opts || {};
    persons.forEach(function (p) {
      var on = p === person;
      if ((p.dataset.open === 'true') !== on) p.dataset.open = on ? 'true' : 'false';
      var bar = p.querySelector('[data-ag-toggle]');
      if (bar) bar.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
    store(OPEN_KEY, person ? person.dataset.eid : null);
    render();
    if (person && opts.scroll !== false) {
      person.style.scrollMarginTop = '84px';
      person.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
  }

  function firstIncomplete(from) {
    for (var i = from || 0; i < persons.length; i++) {
      if (persons[i].dataset.state !== 'done') return persons[i];
    }
    return null;
  }

  // Prvo otvaranje: poslije učitavanja zapisa otvori osobu koja je ostala otvorena, inače prvu nepopunjenu
  function initialOpen() {
    var reg = window.agSki && window.agSki.items;
    var ready = reg && reg.size >= persons.length && !window.agSki.loading;
    tries++;
    if (!ready && tries < 24) return;
    firstOpenDone = true;
    render();
    var remembered = read(OPEN_KEY);
    var target = null;
    persons.forEach(function (p) { if (remembered && p.dataset.eid === remembered) target = p; });
    if (target && target.dataset.state === 'done') target = null; // kompletna osoba se ne otvara ponovo
    if (!target) target = firstIncomplete(0);
    if (target) openPerson(target, { scroll: false });
  }

  // Klik na traku osobe: otvori/zatvori
  persons.forEach(function (person) {
    var bar = person.querySelector('[data-ag-toggle]');
    bar.addEventListener('click', function () {
      if (person.dataset.open === 'true') {
        // otvorena osoba se zatvara kad se otvori druga ili kad se talon upiše; klik na naslov ne radi ništa da se ne izgubi fokus
        return;
      }
      openPerson(person);
    });

    // "Isto kao": prezime iz prethodne osobe
    var chip = person.querySelector('[data-ag-chip-btn]');
    if (chip) {
      chip.addEventListener('click', function () {
        var item = itemOf(person);
        if (!item) return;
        item.lastName = chip.textContent;
        item.onNameBlur('lastName');
        render();
        var dd = person.querySelector('input[data-part="dobDay"]');
        if (dd) dd.focus({ preventScroll: false });
      });
    }
  });

  // Uklanjanje: dva dodira (bez browser dijaloga). Ukloni i vezanu dostavu (naknadu za talon) te osobe.
  root.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-ag-remove]');
    if (!btn) return;
    event.preventDefault();
    if (btn.dataset.armed !== '1') {
      btn.dataset.armed = '1';
      btn.dataset.label = btn.textContent;
      btn.textContent = 'Sigurno ukloniti?';
      setTimeout(function () { btn.dataset.armed = ''; btn.textContent = btn.dataset.label || 'Ukloni'; }, 4000);
      return;
    }
    btn.disabled = true;
    btn.textContent = 'Uklanjam...';
    var person = btn.closest('[data-ag-person]');
    var eid = person ? person.dataset.eid : '';
    var updates = {};
    updates[btn.dataset.agRemove] = 0;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cart.items.forEach(function (it) {
          if (eid && it.properties && String(it.properties._delivery_for_ecomm_ski_product_id) === String(eid)) updates[it.key] = 0;
        });
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates }),
        });
      })
      .then(function () {
        store(OPEN_KEY, null);
        window.location.reload();
      })
      .catch(function (e) {
        console.error(e);
        btn.disabled = false;
        btn.textContent = 'Ukloni kartu';
      });
  });

  // Potvrda Loyalty prava
  if (confirmBox) {
    confirmBox.checked = read(CONFIRM_KEY) === '1';
    confirmBox.addEventListener('change', function () {
      store(CONFIRM_KEY, confirmBox.checked ? '1' : null);
      if (confirmWrap) confirmWrap.dataset.error = 'false';
      render();
    });
  }

  // Dugme "Plati": ne šalje formu dok nije sve kompletno (capture, prije ag-ecommski-cart.js handlera na formi)
  if (pay) {
    pay.addEventListener('click', function (event) {
      var state = render();
      if (state.allDone && state.confirmed) return; // forma ide dalje: ag-ecommski-cart.js sprema sve osobe pa vodi na plaćanje
      event.preventDefault();
      event.stopImmediatePropagation();
      if (!state.allDone) {
        var target = null;
        state.cards.forEach(function (c) { if (!target && c.person.dataset.state !== 'done') target = c; });
        if (target) {
          if (target.item) target.item.isFormValid(); // ispiši poruke u poljima
          openPerson(target.person, { scroll: false });
          setTimeout(function () { scrollToProblem(target.person); }, 120);
        }
      } else if (confirmWrap) {
        confirmWrap.dataset.error = 'true';
        confirmWrap.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }, true);
  }

  // Stanje se čita periodično: komponente su asinhrone (učitavanje zapisa, fotografija, maska talona)
  setInterval(function () {
    if (!firstOpenDone) initialOpen();
    render();
  }, 400);
  render();
})();